import Tooltip from '@material-ui/core/Tooltip';
import AppRouter from 'common/AppRouter';
import TooltipWrapper from 'components/Tooltips/TooltipWrapper';
import { resetTooltipStyle } from 'components/Tooltips/helpers';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import { withRouter } from 'react-router';

export const PRMergedTooltip = withRouter(({ children, history }) => (
  <Tooltip
    interactive
    open
    placement='top'
    classes={resetTooltipStyle()}
    title={
      <TooltipWrapper>
        <Flex direction='column' padding='small'>
          <Flex>
            <Text size='medium'> Can't see your releases?</Text>
          </Flex>
          <Flex>
            <Text
              color='chambray'
              cursor='pointer'
              size='medium'
              onClick={() =>
                history.push({
                  pathname: AppRouter.CONFIGURATION.path,
                  search: '?isOrgSettings=true'
                })
              }
            >
              Change the way your releases are detected
            </Text>
          </Flex>
        </Flex>
      </TooltipWrapper>
    }
  >
    {children}
  </Tooltip>
));
